import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { delete_holiday, get_all_filters_item_holidays, get_all_holidays, get_all_holidays_by_filters } from '../api/holidaysApi';
import "../../../../_metronic/assets/keenicons/outline/style.css";
// import { get_all_users } from '../../../UserManagement/users/api/usersApi';
import Select from 'react-select';
import { Holiday } from '../../../modules/accounts/components/settings/SettingsModel';
import { KTIcon, KTSVG } from '../../../../_metronic/helpers';
import { formatDateWithoutTime, formatDynamicDateTime, formatDynamicDateOnly } from '../../../helper-functions/DateFunction';
import { permissionCheck } from '../../../helper-functions/PermissionCheck';
import { useGeneralSettings } from '../../../contexts/GeneralSettingsContext'
import { get_filtered_users } from '../../users/api/usersApi';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
let holiday_add, holiday_edit, holiday_delete, holiday_log, holiday_view;
type OptionType = {
    value: number
    label: string
}
interface User {
    id: number;
    name: string;
    email?: string;
    // add any other fields you may need
}

interface LocationState {
    user?: User;
}
function HolidaysList() {
  const { getSettingValue } = useGeneralSettings();
  const userDateFormat = getSettingValue('date_format') || 'dd-mm-yyyy';
  const userTimeFormat = getSettingValue('time_format') || '12hr';
  const userTimeZone = getSettingValue('time_zone') || 'UTC';
  

    const [searchInput, setSearchInput] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const employeeNameRef: any = useRef();
    // const [userList, setUserList] = useState<User[]>([]);
    const [visibleData, setVisibleData] = useState<Holiday[]>([]);
    // const [selectedEmployee, setSelectedEmployee] = useState('');
    const [HolidayList, setHolidayList] = useState<Holiday[]>([]);
    const [selectedholiday, setSelectedholiday] = useState<Holiday | null>(null);
    const [selectedItemsPerPage, setSelectedItemsPerPage] = useState(10); // Step 1: State variable for items per page
    const [sortBy, setSortBy] = useState<{ key: string, ascending: boolean } | null>(null); // State variable for sorting
    const location = useLocation();
    const state = location.state as LocationState;
    const user = state?.user || null;
    const [fromDate, setFromDate] = useState<string>('');
    const [toDate, setToDate] = useState<string>('');

    const [userId, setUserId] = useState<number | "">(
        user?.id || ""
    );
    const [users, setUsers] = useState<User[]>([]);
    const [selectedUsers, setSelectedUsers] = useState<OptionType[]>([])
    const [userOptions, setUserOptions] = useState<{ label: string; value: number }[]>([]);
    useEffect(() => {
        async function fetchUsers() {
            try {
                const response = await get_filtered_users('', 1, 100);
                if (response?.data?.data?.data) {
                    const formatted = response?.data?.data?.data.map((u: any) => ({
                        label: u.fullname || `${u.firstname} ${u.lastname}`,
                        value: u.id,
                    }));
                    setUserOptions(formatted);
                }
            } catch (error) {
                console.error('Failed to fetch users', error);
            }
        }
        fetchUsers();
    }, []);
    useEffect(() => {
        holiday_add = permissionCheck('holiday-create')
        holiday_edit = permissionCheck('holiday-update')
        holiday_delete = permissionCheck('holiday-delete')
        holiday_view = permissionCheck('holiday-view')
        holiday_log = permissionCheck('holiday-activity-log')
    }, [])
    // const { data:employeeData, isError, isLoading, refetch: refetchUsers } = useQuery('employee', get_all_users,{ refetchOnWindowFocus: false });
    const navigate = useNavigate();
    // useEffect(() => {
    //     if (employeeData) {
    //       setUserList(employeeData.data)
    //     }
    //   }, [employeeData]);
    const { refetch: refetchUsers } = useQuery(
        ["filteredUsers"],
        () => get_filtered_users("", 1, 100),
        {
            onSuccess: (res) => {
                setUsers(res.data?.data || []);
            },
            onError: (error: any) => {
                toast.error("Failed to load users");
            },
        }
    );
    const { data: allHoliday,
        isLoading: isAllHoliday,
        isError: isAllHolidayError,
        refetch: refetchHoliday } = useQuery(
            'filterData',
            () => get_all_holidays(),
            {
                onSuccess: (filteredData) => {
                    setHolidayList(filteredData.data);
                },
                onError: (error: any) => {
                    // Optionally, you can display a toast or any other error handling mechanism
                    if (error.response) {
                        const errorMessage = error.response.data.message;
                        toast.error(errorMessage, {
                            position: 'top-right',
                            autoClose: 4000,
                        })
                    };
                },
                enabled: true,
                refetchOnWindowFocus: false
            }
        );
    const handleApplyFilters = async () => {
        const payload = {
            from_date: fromDate || undefined,
            to_date: toDate || undefined,
            // title: title || undefined,
            users: selectedUsers.map((u) => u.value),
            // updated_by: updatedBy || undefined,
        };

        console.log("Filter payload:", payload);

        try {
            const response = await get_all_holidays_by_filters(payload);
            console.log("Filtered Holidays:", response.data);
            setHolidayList(response.data);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleClearFilters = async () => {
        // Reset all filter states
        setFromDate('');
        setToDate('');
        setSelectedUsers([]);
        // setTitle('');
        // setUpdatedBy('');

        // Optionally refetch full holiday list
        try {
            const response = await get_all_holidays_by_filters({});
            setHolidayList(response.data);
        } catch (error) {
            console.error('Error fetching all holidays after clear:', error);
        }
    };

    const itemsPerPageOptions = [10, 20, 30, 50, 100]; // Step 2: Options for items per page
    const totalItems = HolidayList.length;
    const totalPages = Math.ceil(totalItems / selectedItemsPerPage); // Update total pages based on selected items per page
    useEffect(() => {
        if (HolidayList.length > 0) {
            let sortedData = [...HolidayList];
            if (sortBy) {
                sortedData.sort((a, b) => {
                    const aValue = (a[sortBy?.key] || '') as string;
                    const bValue = (b[sortBy?.key] || '') as string;
                    return sortBy.ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                });
            }
            setVisibleData(
                sortedData.slice(
                    (currentPage - 1) * selectedItemsPerPage,
                    currentPage * selectedItemsPerPage
                )
            );
        }
    }, [HolidayList, currentPage, selectedItemsPerPage, sortBy]);
    // Search holiday
    const handleInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const searchTerm = e.currentTarget.value.toLowerCase();
        setSearchInput(searchTerm);
        const filteredItems = allHoliday.data.filter((holiday) => {
            return (
                holiday.title?.toLowerCase().includes(searchTerm) ||
                holiday.holiday_type_name?.toLowerCase().includes(searchTerm) ||
                holiday.title?.toUpperCase().includes(searchTerm) ||
                holiday.holiday_type_name?.toUpperCase().includes(searchTerm)
            )
        });
        setHolidayList(filteredItems);
    }, [allHoliday]);
    // Delete holiday
    const handleDeleteHoliday = useMutation((id: number) => {
        return delete_holiday(id)
            .then((response) => {
                toast.success(response.message, {
                    position: 'top-right',
                    autoClose: 3000,
                });
            })
            .then(() => {
                refetchHoliday();
            })
            .catch((error: any) => {
                if (error.response) {
                    const errorMessage = error.response.data.message;
                    toast.error(errorMessage, {
                        position: 'top-right',
                        autoClose: 4000,
                    })
                }
            });
    });
    // Handle Sort
    const handleSort = (key: string) => {
        if (!sortBy || sortBy.key !== key || sortBy.ascending) {
            setSortBy({ key, ascending: false }); // Sort in descending order initially
        } else if (key === "updated_at") {
            // Toggle between ascending and descending order
            setSortBy({ key, ascending: true });
        } else if (key === "updated_by_name") {
            // Toggle between ascending and descending order
            setSortBy({ key, ascending: !sortBy.ascending });
        } else if (key === "holiday_type_name") {
            // Toggle between ascending and descending order
            setSortBy({ key, ascending: !sortBy.ascending });
        }
        else {
            setSortBy(null); // Revert to unsorted state
        }
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const handleEditholidayType = (holiday) => {
        navigate("/holidays/edit-holiday", { state: { id: holiday.id } });
    };
    const handleHolidayLogs = (data: any) => {
        navigate("/holidays/holiday-logs", { state: { id: data.id } });
    };
    const handleHolidayView = (holiday: any) => {
        navigate("/holidays/view-holiday", { state: { id: holiday.id } });
    };
    const handleAddHoliday = () => {
        if (user) {
            // If user exists, navigate with user info
            navigate("/holidays/add-holiday", { state: { user } });
        } else {
            // Otherwise, just go to general add holiday page
            navigate("/holidays/add-holiday");
        }
    };
    // Add react-select for searchable dropdown
    //   const employeeOptions = (Array.isArray(userList) ? userList : []).map(user => ({
    //     value: user.id,
    //     label: user.full_name
    // }));    
    return (
        <div className='card mb-5 mb-xl-10'>
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>List of Holidays</span>
                </h3>
                {
                    holiday_add && (
                        <div
                            className='card-toolbar'
                        >
                            <button
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title={user ? `Add holiday for ${user.name || "selected user"}` : "Add holiday"}
                                className="btn btn-sm btn-light-dark"
                                onClick={handleAddHoliday}
                            >
                                <KTIcon iconName="plus" className="fs-3" />
                                Add holiday
                            </button>
                        </div>
                    )
                }
            </div>
            <div className='card-header border-0 pt-5 row'>
                <div className='card-title col-lg-6'>
                    {/* begin::Search */}
                    <div className='d-flex align-items-center my-1'>
                        <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                        <input
                            data-toggle="tooltip" data-placement="bottom" title="Search for a holiday"
                            type='text'
                            data-kt-user-table-filter='search'
                            className='form-control form-control-solid w-250px ps-14'
                            placeholder='Search holiday'
                            value={searchInput}
                            onChange={handleInputChange}
                        />
                    </div>
                    {/* end::Search */}
                </div>
            </div>
            <div className='card-header border-0 pt-5'>
                <div className='mx-2'>
                    <div className='d-flex'>
                        {/* <div className='mx-4 mt-1'>
                            <Select
                                ref={employeeNameRef}
                                options={employeeOptions}
                                value={employeeOptions.find(option => option.value.toString() === selectedEmployee)}
                                onChange={(selectedOption) => setSelectedEmployee(selectedOption ? selectedOption.value.toString() : '')}
                                isClearable
                                placeholder='Filter by Updated By...'
                            />
                        </div> */}
                    </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <div>
                        <label className="form-label fw-semibold">From Date:</label>
                        <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="form-label fw-semibold">To Date:</label>
                        <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                    {/* User Multi-select */}
                    <div className="col-md-4">
                        <label className="form-label fw-semibold">Select Users</label>
                        <Select<OptionType, true>
                            isMulti
                            options={userOptions}
                            value={selectedUsers}
                            onChange={(value) => setSelectedUsers([...value])}
                            classNamePrefix="react-select"
                            placeholder="Filter by users..."
                        />
                    </div>
                </div>
                <div className='card-header border-0 pt-5 mx-3 d-flex flex-column align-items-end'>
                    <div>
                        <button
                            className='btn btn-primary me-3'
                            onClick={handleApplyFilters}
                        >
                            Apply Filters
                        </button>
                        <button
                            className='btn btn-light-danger'
                            onClick={handleClearFilters}
                        >
                            Clear Filters
                        </button>
                    </div>
                </div>
            </div>
            <div className='card-body py-3'>
                <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* Headings of columns in table  */}
                        <thead>
                            <tr className='fw-bold text-muted'>
                                <th className='min-w-120px'>Holiday<span onClick={() => handleSort('title')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                {/* <th className='min-w-140px'>Holiday Type<span onClick={() => handleSort('holiday_type_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th> */}
                                <th className='min-w-150px'>Holidays For<span onClick={() => handleSort('holiday_for')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-150px'>From Date<span onClick={() => handleSort('from_date')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-150px'>To Date<span onClick={() => handleSort('to_date')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-150px'>Updated By <span onClick={() => handleSort('updated_by_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-100px'>Updated At <span onClick={() => handleSort('updated_at')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                {
                                    holiday_edit || holiday_delete || holiday_view ? (
                                        <th className='min-w-100px text-center'>Actions</th>
                                    ) : null
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {isAllHolidayError ? (
                                <tr>
                                    <td>Error loading data. Please try again later.</td>
                                </tr>
                            ) : isAllHoliday ? (
                                <tr>
                                    <td colSpan={6}>
                                        <div className='text-center'>
                                            <div className='spinner-border' role='status'>
                                                <span className='visually-hidden'>Loading...</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ) : HolidayList.length > 0 ? (
                                visibleData.map((holiday) => (
                                    <tr key={holiday.id}>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start flex-column'>
                                                    <h3 className='text-dark fw-bold  fs-6'>
                                                        {holiday.title}
                                                    </h3>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start flex-column'>
                                                    <h3 className='text-dark fw-bold  fs-6'>
                                                        {holiday.holiday_for}
                                                    </h3>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start'>
                                                    {formatDynamicDateOnly(holiday.from_date, userDateFormat, userTimeZone)}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start'>
                                                    {formatDynamicDateOnly(holiday.to_date, userDateFormat, userTimeZone)}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start'>
                                                    {holiday.updated_by_name}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start'>
                                                    {formatDynamicDateTime(holiday.updated_at, userDateFormat, userTimeFormat, userTimeZone)}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex justify-content-end flex-shrink-0'>
                                                {
                                                    holiday_view && (
                                                        <button
                                                            data-toggle="tooltip" data-placement="bottom" title="See holiday Details"
                                                            onClick={() => handleHolidayView(holiday)}
                                                            className='btn btn-icon btn-light-dark btn-active-color-warning btn-sm me-1'
                                                        >
                                                            <KTIcon iconName='eye' className='fs-3' />
                                                        </button>
                                                    )
                                                }
                                                {
                                                    holiday_log && (
                                                        <button
                                                            data-toggle="tooltip" data-placement="bottom" title="View holiday Log"
                                                            className='btn btn-icon btn-light-dark btn-active-color-warning btn-sm me-1'
                                                            onClick={() => handleHolidayLogs(holiday)}
                                                        >
                                                            <i className='bi bi-journal-text'></i>
                                                        </button>
                                                    )
                                                }
                                                {
                                                    holiday_edit && (
                                                        <button
                                                            data-toggle="tooltip" data-placement="bottom" title="Edit holiday"
                                                            className='btn btn-icon btn-light-dark btn-active-color-warning btn-sm me-1'
                                                            onClick={() => {
                                                                handleEditholidayType({ ...holiday });
                                                            }}
                                                        >
                                                            <KTIcon iconName='pencil' className='fs-3' />
                                                        </button>
                                                    )
                                                }
                                                {
                                                    holiday_delete && (
                                                        <button
                                                            data-toggle="tooltip" data-placement="bottom" title="Delete holiday"
                                                            onClick={() => setSelectedholiday(holiday)}
                                                            className='btn btn-icon btn-light-dark btn-active-color-danger btn-sm'
                                                            data-bs-toggle='modal'
                                                            data-bs-target='#kt_modal_1'
                                                        >
                                                            <KTIcon iconName='trash' className='fs-3' />
                                                        </button>
                                                    )
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td>No holidays available.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* Delete modal */}
            <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
                <div className='modal-dialog'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Delete Holiday Confirmation</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            {selectedholiday ? (
                                <>
                                    <p className='mb-2'>
                                        <span className='fw-bold'>Title: </span> {selectedholiday.title}
                                    </p>
                                </>
                            ) : null}
                        </div>
                        <div className='modal-footer'>
                            <button data-toggle="tooltip" data-placement="bottom" title="Close" type='button' className='btn btn-light' data-bs-dismiss='modal'>
                                Close
                            </button>
                            <button
                                data-toggle="tooltip" data-placement="bottom" title="Delete this holiday"
                                type='button'
                                onClick={() => {
                                    if (selectedholiday && selectedholiday.id) {
                                        handleDeleteHoliday.mutate(selectedholiday.id)
                                    }
                                }}
                                className='btn btn-danger'
                                data-bs-dismiss='modal'
                            >
                                Delete holiday
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer d-flex justify-content-between align-items-center py-4'>
                <div className='d-flex align-items-center'>
                    <strong className='me-3'>Results Per Page:</strong>
                    <select
                        className='form-select form-select-sm form-select-solid'
                        style={{ width: '80px' }}
                        value={selectedItemsPerPage}
                        onChange={(e) => {
                            setSelectedItemsPerPage(Number(e.target.value));
                            setCurrentPage(1); // Reset to page 1 when changing items per page
                        }}
                    >
                        {itemsPerPageOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                </div>

                <div className='d-flex align-items-center'>
                    <span className='text-muted me-3'>
                        Page <strong>{currentPage}</strong> of <strong>{totalPages || 1}</strong>
                    </span>
                    <div className='d-flex'>
                        <button
                            className='btn btn-light-primary btn-sm'
                            onClick={handlePreviousPage}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <button
                            className='btn btn-primary btn-sm ms-2'
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default HolidaysList;